import { createFileRoute, Navigate, redirect } from "@tanstack/react-router";

import { DASHBOARD_PATH, LOGIN_PATH } from "~/routes/-route-constants/appRoutes.ts";

export const Route = createFileRoute("/")({
    beforeLoad: ({ context }) => {
        if (!context.auth.user) {
            throw redirect({ to: LOGIN_PATH });
        }
    },
    component: () => <Navigate to={DASHBOARD_PATH} />,
});
